export const selectUserPinResponse = (state: IGlobalState): UserPinResponse | undefined =>
  state.userPin.userPin
